import React from 'react';
// @ts-ignore
import Text from '../../Base/Text/Text';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import styles from './TextArea.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import { FieldError } from 'react-hook-form';
import { useValidation } from '../../Utils/Validation';
import AudioToText from '../../../Modules/Base/Components/AudioToText/AudioToText';
import { Position } from '../../../Modules/Base/Enums/Position.enum';

interface ITextArea {
	onChange?: any;
	onFocus?: any;
	onKeyPress?: any;
	onKeyUp?: any;
	onKeyDown?: any;
	placeholder?: string;
	required?: boolean;
	value?: string;
	className?: string;
	rows?: number;
	wrapperClassName?: string;
	style?: any;
	error?: FieldError;
	disabled?: boolean;
	captureAudio?: {
		allow: boolean;
		position: Position;
	};
}

export default function TextArea(props: ITextArea) {
	const {
		onChange,
		onFocus,
		onKeyPress,
		onKeyUp,
		onKeyDown,
		placeholder,
		required = false,
		value,
		className,
		rows = 3,
		style,
		wrapperClassName,
		error,
		disabled,
		captureAudio,
		...rest
	} = props;
	const { fillErrorMessage } = useValidation();

	const handleOnChange = e => {
		onChange?.(e);
	};

	return (
		<div
			className={joinClasses([
				wrapperClassName ?? styles.wrapper,
				captureAudio?.position === Position.LEFT
					? styles.withAudioLeft
					: styles.withAudioRight,
			])}>
			{captureAudio?.allow && (
				<AudioToText
					value={value}
					onCapture={onChange}
					position={captureAudio.position}
				/>
			)}
			<textarea
				{...rest}
				value={value || ''}
				placeholder={placeholder}
				onKeyPress={onKeyPress}
				onKeyDown={onKeyDown}
				onKeyUp={onKeyUp}
				onChange={onChange}
				onFocus={onFocus}
				style={style}
				disabled={disabled}
				className={joinClasses([
					className,
					styles.input,
					error ? styles.invalid : '',
					disabled ? styles.disabled : undefined,
				])}
				rows={rows}
			/>
			{error && error.message && (
				<div className={styles.errorMessage}>
					<Text tx={fillErrorMessage(error)} inline />
				</div>
			)}
		</div>
	);
}
